import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import ActivityType from '../../entities/activityType';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';

/*
 * Delete/nullify anywhere this activityType is used in other entities
 *
 * @param {ActivityType} activityType
 */
export function deleteActivityType(activityType: ActivityType, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = activityType.id;
    }
    /* Simple delete usages */
        
    store.getState().tasks
        .getMappingFor('activityTypeId', activityType.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.activityTypeIds = _task.activityTypeIds?.filter(id => id !== activityType.id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('activityTypeId', activityType.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.activityTypeIds = _templateTask.activityTypeIds?.filter(id => id !== activityType.id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    /* Remove the actual activityType */
    activityType.status = 'D';
    activityType.addedOn = newHRTimestamp();
    activityType.addedBy = getCurrentUserId();
    activityType.importSource = targetImportSource;
    activityType.importId = mergeId;
    store.dispatch(Actions.ActivityTypeActions.removeActivityTypeQueue(activityType));
    
}

/*
 * Replace anywhere this activityType is used in other entities.
 *
 * @param {ActivityType} activityType
 * @param {ActivityType} replaceWith
 * @return {ActivityType} - ActivityType will have refs stripped away
 */
export function replaceActivityType(activityType: ActivityType, replaceWith: ActivityType, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = activityType.id;
    }
    /* Simple replace usages */
        
    store.getState().tasks
        .getMappingFor('activityTypeId', activityType.id)
        .filter(taskTemp => taskTemp.status !== 'D')
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.status =  'U';
            _task.addedOn = newHRTimestamp();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;

            _task.activityTypeIds = _task.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    store.getState().templateTasks
        .getMappingFor('activityTypeId', activityType.id)
        .filter(templateTaskTemp => templateTaskTemp.status !== 'D')
        .forEach(templateTaskTemp => {
            const _templateTask = templateTaskTemp.clone();
            _templateTask.status =  'U';
            _templateTask.addedOn = newHRTimestamp();
            _templateTask.importSource = targetImportSource;
            _templateTask.importId = mergeId;

            _templateTask.activityTypeIds = _templateTask.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
        });

    return activityType;
}

/*
 * Determine the impact of deleting this activityType from other entities
 *
 * @param {ActivityType} activityType
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactActivityType(activityType: ActivityType) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const taskActivityTypeIdsImpact = state.tasks
          .getMappingFor('activityTypeId', activityType.id)
          .filter(task => task.status !== 'D');

    taskActivityTypeIdsImpact.forEach(() => impacts.push('tasks'));

    const templateTaskActivityTypeIdsImpact = state.templateTasks
          .getMappingFor('activityTypeId', activityType.id)
          .filter(templateTask => templateTask.status !== 'D');

    templateTaskActivityTypeIdsImpact.forEach(() => impacts.push('templateTasks'));

    return util.countDistinct(impacts);
}